import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import HeroSection from './components/HeroSection';
import CategoryTiles from './components/CategoryTiles';
import DailySpecials from './components/DailySpecials';
import TestimonialCarousel from './components/TestimonialCarousel';
import LocationWidget from './components/LocationWidget';
import NewsletterSection from './components/NewsletterSection';
import InstagramFeed from './components/InstagramFeed';

const Homepage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-20">
        <HeroSection />
        <CategoryTiles />
        <DailySpecials />
        <TestimonialCarousel />
        <LocationWidget />
        <InstagramFeed />
        <NewsletterSection />
      </main>

      <Footer />
    </div>
  );
};

export default Homepage;